import * as yup from 'yup'

/**
 * 사전예약 form values
 *
 * @type TPreReservationFormValues
 * @property {string} companyId - 회사 id
 * @property {string} termId
 * @property {string} subsidiaryId - 계열사 id
 * @property {string} departmentId - 사업부 id
 * @property {string} jobId - 직무 id
 * @property {string} testId - 응시 날짜 id
 * @property {string} phoneNumber - 후대폰 번호
 * @property {boolean} hasAgreedToPrivacy - 개인정보 수집/이용 및 마케팅 수신 동의 여부
 **/
export type TPreReservationFormValues = {
  companyId: string
  termId: string
  subsidiaryId: string
  departmentId: string
  jobId: string
  testId: string
  phoneNumber: string
  hasAgreedToPrivacy: boolean
}

export const preReservationSchema = yup.object().shape({
  companyId: yup.string().required(),
  termId: yup.string().required(),
  subsidiaryId: yup.string().required(),
  departmentId: yup.string().required(),
  jobId: yup.string().required(),
  testId: yup.string().required(),
  phoneNumber: yup
    .string()
    .test({
      name: 'is-valid-number',
      test: (phoneNumber) => {
        const isEmpty = !phoneNumber
        if (isEmpty) {
          return true
        }

        const onlyNumber = phoneNumber.replace(/-/g, '')

        const isLength = onlyNumber.length === 11 || onlyNumber.length === 10

        return isLength
      },
    })
    .required(),
  hasAgreedToPrivacy: yup
    .boolean()
    .test('is-agreed-to-privacy', (value) => value === true),
})
